export const LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "id", label: "Bahasa Indonesia", flag: "🇮🇩" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
];

const dict = {
  en: {
    "nav.login": "Log in",
    "nav.signup": "Sign up",
    "nav.account": "My Account",
    "hero.badge": "LIVE TRAINING MARKETPLACE",
    "hero.title1": "Shop the feed.",
    "hero.title2": "Learn the flow.",
    "hero.subtitle": "A realistic Shop seller experience for training — browse trending products, checkout with simulated balance, and watch orders move through the pipeline.",
    "search.placeholder": "Search products...",
    "search.button": "Search",
    "feat.trending": "Trending picks",
    "feat.fast": "Fast fulfilment",
    "feat.curated": "Seller-curated",
    "product.sold": "sold",
    "product.addToCart": "Add to cart",
    "product.none": "No products found.",
    "footer": "Seller Center · Training sandbox for education. Not affiliated with any real marketplace.",
    "header.sandbox": "TRAINING SANDBOX · Simulated money",
    "toast.added": "Added to cart",
    "auth.loginTitle": "Login",
    "auth.signupTitle": "Sign up",
    "auth.phoneEmail": "Phone Number / Email",
    "auth.enterPassword": "Enter Password",
    "auth.loginPasswordPh": "Login Password",
    "auth.merchant": "Merchant onboarding",
    "auth.noAccount": "No account?",
    "auth.signup": "Sign up",
    "auth.loginBtn": "Login",
    "auth.loggingIn": "Logging in...",
    "auth.demo": "Demo accounts",
    "auth.name": "Name",
    "auth.namePh": "Your full name",
    "auth.emailPh": "Phone Number /  Email",
    "auth.setPassword": "Set Password",
    "auth.setPasswordPh": "At least 6 characters",
    "auth.already": "Already have an account?",
    "auth.login": "Log in",
    "auth.creating": "Creating...",
    "nav.dashboard": "Dashboard",
    "nav.products": "Products",
    "nav.orders": "Orders",
    "nav.payouts": "Payouts",
    "nav.storefront": "Storefront",
    "nav.wallet": "Wallet",
    "nav.becomeSeller": "Become a Seller",
    "nav.myOrders": "My Orders",
    "nav.sellerApprovals": "Seller Approvals",
    "nav.productApprovals": "Product Approvals",
    "nav.allOrders": "All Orders",
    "nav.users": "Users",
    "nav.logout": "Log out",
    "panel.suffix": "panel",
    "role.seller": "seller",
    "role.buyer": "buyer",
    "role.admin": "admin",
    "cat.All": "All", "cat.Fashion": "Fashion", "cat.Beauty": "Beauty",
    "cat.Electronics": "Electronics", "cat.Home": "Home", "cat.Toys": "Toys",
    "cat.Sports": "Sports", "cat.General": "General",
  },
  es: {
    "nav.login": "Iniciar sesión",
    "nav.signup": "Registrarse",
    "nav.account": "Mi cuenta",
    "hero.badge": "MERCADO DE PRÁCTICAS EN VIVO",
    "hero.title1": "Compra en el feed.",
    "hero.title2": "Aprende el flujo.",
    "hero.subtitle": "Una experiencia realista de vendedor para practicar: explora productos de tendencia, paga con saldo simulado y observa cómo avanzan los pedidos.",
    "search.placeholder": "Buscar productos...",
    "search.button": "Buscar",
    "feat.trending": "Tendencias",
    "feat.fast": "Envío rápido",
    "feat.curated": "Elegido por vendedores",
    "product.sold": "vendidos",
    "product.addToCart": "Añadir al carrito",
    "product.none": "No se encontraron productos.",
    "footer": "Seller Center · Entorno de práctica educativo. No afiliado a ningún mercado real.",
    "header.sandbox": "ENTORNO DE PRÁCTICAS · Dinero simulado",
    "toast.added": "Añadido al carrito",
    "auth.loginTitle": "Iniciar sesión",
    "auth.signupTitle": "Registrarse",
    "auth.phoneEmail": "Número de teléfono / Correo",
    "auth.enterPassword": "Introduce la contraseña",
    "auth.loginPasswordPh": "Contraseña",
    "auth.merchant": "Alta de vendedor",
    "auth.noAccount": "¿No tienes cuenta?",
    "auth.signup": "Regístrate",
    "auth.loginBtn": "Entrar",
    "auth.loggingIn": "Entrando...",
    "auth.demo": "Cuentas de prueba",
    "auth.name": "Nombre",
    "auth.namePh": "Tu nombre completo",
    "auth.emailPh": "Número de teléfono /  Correo",
    "auth.setPassword": "Crea una contraseña",
    "auth.setPasswordPh": "Al menos 6 caracteres",
    "auth.already": "¿Ya tienes una cuenta?",
    "auth.login": "Inicia sesión",
    "auth.creating": "Creando...",
    "nav.dashboard": "Panel",
    "nav.products": "Productos",
    "nav.orders": "Pedidos",
    "nav.payouts": "Pagos",
    "nav.storefront": "Tienda",
    "nav.wallet": "Billetera",
    "nav.becomeSeller": "Ser vendedor",
    "nav.myOrders": "Mis pedidos",
    "nav.sellerApprovals": "Aprobar vendedores",
    "nav.productApprovals": "Aprobar productos",
    "nav.allOrders": "Todos los pedidos",
    "nav.users": "Usuarios",
    "nav.logout": "Cerrar sesión",
    "panel.suffix": "panel",
    "role.seller": "vendedor",
    "role.buyer": "comprador",
    "role.admin": "administrador",
    "cat.All": "Todos", "cat.Fashion": "Moda", "cat.Beauty": "Belleza",
    "cat.Electronics": "Electrónica", "cat.Home": "Hogar", "cat.Toys": "Juguetes",
    "cat.Sports": "Deportes", "cat.General": "General",
  },
  id: {
    "nav.login": "Masuk",
    "nav.signup": "Daftar",
    "nav.account": "Akun Saya",
    "hero.badge": "PASAR PELATIHAN LANGSUNG",
    "hero.title1": "Belanja dari feed.",
    "hero.title2": "Pelajari alurnya.",
    "hero.subtitle": "Pengalaman penjual yang realistis untuk pelatihan — jelajahi produk tren, bayar dengan saldo simulasi, dan lihat pesanan berjalan melalui alurnya.",
    "search.placeholder": "Cari produk...",
    "search.button": "Cari",
    "feat.trending": "Pilihan tren",
    "feat.fast": "Pengiriman cepat",
    "feat.curated": "Kurasi penjual",
    "product.sold": "terjual",
    "product.addToCart": "Tambah ke keranjang",
    "product.none": "Produk tidak ditemukan.",
    "footer": "Seller Center · Sandbox pelatihan untuk edukasi. Tidak berafiliasi dengan pasar mana pun.",
    "header.sandbox": "SANDBOX PELATIHAN · Uang simulasi",
    "toast.added": "Ditambahkan ke keranjang",
    "auth.loginTitle": "Masuk",
    "auth.signupTitle": "Daftar",
    "auth.phoneEmail": "Nomor Telepon / Email",
    "auth.enterPassword": "Masukkan Kata Sandi",
    "auth.loginPasswordPh": "Kata Sandi",
    "auth.merchant": "Pendaftaran penjual",
    "auth.noAccount": "Belum punya akun?",
    "auth.signup": "Daftar",
    "auth.loginBtn": "Masuk",
    "auth.loggingIn": "Memproses...",
    "auth.demo": "Akun demo",
    "auth.name": "Nama",
    "auth.namePh": "Nama lengkap Anda",
    "auth.emailPh": "Nomor Telepon /  Email",
    "auth.setPassword": "Buat Kata Sandi",
    "auth.setPasswordPh": "Minimal 6 karakter",
    "auth.already": "Sudah punya akun?",
    "auth.login": "Masuk",
    "auth.creating": "Membuat...",
    "nav.dashboard": "Dasbor",
    "nav.products": "Produk",
    "nav.orders": "Pesanan",
    "nav.payouts": "Pencairan",
    "nav.storefront": "Toko",
    "nav.wallet": "Dompet",
    "nav.becomeSeller": "Jadi Penjual",
    "nav.myOrders": "Pesanan Saya",
    "nav.sellerApprovals": "Persetujuan Penjual",
    "nav.productApprovals": "Persetujuan Produk",
    "nav.allOrders": "Semua Pesanan",
    "nav.users": "Pengguna",
    "nav.logout": "Keluar",
    "panel.suffix": "panel",
    "role.seller": "penjual",
    "role.buyer": "pembeli",
    "role.admin": "admin",
    "cat.All": "Semua", "cat.Fashion": "Fesyen", "cat.Beauty": "Kecantikan",
    "cat.Electronics": "Elektronik", "cat.Home": "Rumah", "cat.Toys": "Mainan",
    "cat.Sports": "Olahraga", "cat.General": "Umum",
  },
  fr: {
    "nav.login": "Connexion",
    "nav.signup": "S'inscrire",
    "nav.account": "Mon compte",
    "hero.badge": "MARCHÉ DE FORMATION EN DIRECT",
    "hero.title1": "Achetez dans le feed.",
    "hero.title2": "Apprenez le flux.",
    "hero.subtitle": "Une expérience de vendeur réaliste pour s'entraîner — parcourez les produits tendance, payez avec un solde simulé et suivez les commandes.",
    "search.placeholder": "Rechercher des produits...",
    "search.button": "Rechercher",
    "feat.trending": "Tendances",
    "feat.fast": "Livraison rapide",
    "feat.curated": "Sélection vendeurs",
    "product.sold": "vendus",
    "product.addToCart": "Ajouter au panier",
    "product.none": "Aucun produit trouvé.",
    "footer": "Seller Center · Environnement de formation éducatif. Non affilié à un marché réel.",
    "header.sandbox": "BAC À SABLE DE FORMATION · Argent simulé",
    "toast.added": "Ajouté au panier",
    "auth.loginTitle": "Connexion",
    "auth.signupTitle": "Inscription",
    "auth.phoneEmail": "Numéro de téléphone / E-mail",
    "auth.enterPassword": "Saisir le mot de passe",
    "auth.loginPasswordPh": "Mot de passe",
    "auth.merchant": "Inscription marchand",
    "auth.noAccount": "Pas de compte ?",
    "auth.signup": "S'inscrire",
    "auth.loginBtn": "Se connecter",
    "auth.loggingIn": "Connexion...",
    "auth.demo": "Comptes de démo",
    "auth.name": "Nom",
    "auth.namePh": "Votre nom complet",
    "auth.emailPh": "Numéro de téléphone /  E-mail",
    "auth.setPassword": "Créer un mot de passe",
    "auth.setPasswordPh": "Au moins 6 caractères",
    "auth.already": "Vous avez déjà un compte ?",
    "auth.login": "Se connecter",
    "auth.creating": "Création...",
    "nav.dashboard": "Tableau de bord",
    "nav.products": "Produits",
    "nav.orders": "Commandes",
    "nav.payouts": "Paiements",
    "nav.storefront": "Boutique",
    "nav.wallet": "Portefeuille",
    "nav.becomeSeller": "Devenir vendeur",
    "nav.myOrders": "Mes commandes",
    "nav.sellerApprovals": "Validation vendeurs",
    "nav.productApprovals": "Validation produits",
    "nav.allOrders": "Toutes les commandes",
    "nav.users": "Utilisateurs",
    "nav.logout": "Déconnexion",
    "panel.suffix": "panneau",
    "role.seller": "vendeur",
    "role.buyer": "acheteur",
    "role.admin": "admin",
    "cat.All": "Tous", "cat.Fashion": "Mode", "cat.Beauty": "Beauté",
    "cat.Electronics": "Électronique", "cat.Home": "Maison", "cat.Toys": "Jouets",
    "cat.Sports": "Sport", "cat.General": "Général",
  },
};

export function translate(lang, key) {
  return (dict[lang] && dict[lang][key]) || dict.en[key] || key;
}
